export default "__VITE_ASSET__kUCedOdH__"